<template>
	<div>
		<div
			class="modal fade"
			id="copyLink"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">{{title}}</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "resetAction()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px">
						<div class = "form-group row" style = "display: flex;align-items: center;">
							<div class = "col-md-8">
								<input :value = "url + item" class="form-control" id = "copyText"/>
							</div>
							<div class = "" style = "border:1px #e5e5e5 solid">
								<button style="border:0px" @click = "copyLinkData">
									<i class="fa fa-clipboard" aria-hidden="true" style = "padding:4px;color:#212529"></i>
								</button>
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "resetAction()">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CopyReleaseLink",
		props:["item", "title"],
		data() {
			return {
				url:''
			};
		},
		components: {
		},
		mounted() {
			this.url = window.location.origin + "/#/releaseDetail/"
			//this.openCampaignGroup();
		},
		watch: {},
		methods: {
			resetAction(){
				this.$emit("resetAction")
			},
			copyLinkData(){
				  var copyText = document.getElementById("copyText");
				  copyText.select();
				  document.execCommand("copy");

			}
		}

	};
</script>
<style lang="scss">
</style>
